import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\components\\AnalyticsScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\components\\CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieProvider"] */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\components\\CookieContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\components\\ThemeClient.tsx");
;
import(/* webpackMode: "eager" */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "D:\\Portfolio_Programacao\\GitHub\\Renata-Landing-Page-Version-2\\styles\\globals.scss");
